var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Base", {
    attrs: { "show-search": true, title: _vm.curr_title },
    scopedSlots: _vm._u([
      {
        key: "topbar-content",
        fn: function () {
          return [_c("UploadButton")]
        },
        proxy: true,
      },
      {
        key: "main-content",
        fn: function () {
          return [
            _c(
              "v-container",
              { attrs: { fluid: "", "grid-list-md": "", "pa-2": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { justify: "space-between" } },
                  [
                    _c("v-col", { attrs: { cols: "8" } }, [
                      _c("div", { staticStyle: { position: "relative" } }, [
                        _c("h1", [_vm._v("Results Comparison")]),
                      ]),
                    ]),
                    _c("v-col", { attrs: { cols: "4" } }, [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-nowrap" },
                        [
                          _c("h4", { staticClass: "pt-5 pr-1" }, [
                            _vm._v("Sort Results Sets By:"),
                          ]),
                          _c("v-select", {
                            attrs: { items: _vm.compareItems },
                            model: {
                              value: _vm.sortControlSetsBy,
                              callback: function ($$v) {
                                _vm.sortControlSetsBy = $$v
                              },
                              expression: "sortControlSetsBy",
                            },
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.reverseSort = !_vm.reverseSort
                                },
                              },
                            },
                            [
                              _c("v-icon", [
                                _vm._v(
                                  _vm._s(
                                    _vm.reverseSort
                                      ? "mdi-sort-descending"
                                      : "mdi-sort-ascending"
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "v-tabs",
                  {
                    attrs: { "fixed-tabs": "", "show-arrows": "" },
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c(
                      "v-tab",
                      {
                        key: "status",
                        on: {
                          click: function ($event) {
                            return _vm.changeTab(0)
                          },
                        },
                      },
                      [
                        _c(
                          "v-flex",
                          [
                            _vm._v(" Status by Results File "),
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-unfold-more-horizontal"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-tab",
                      {
                        key: "compliance",
                        on: {
                          click: function ($event) {
                            return _vm.changeTab(1)
                          },
                        },
                      },
                      [
                        _c(
                          "v-flex",
                          [
                            _vm._v(" % Compliance "),
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-unfold-more-horizontal"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-tab",
                      {
                        key: "severity",
                        on: {
                          click: function ($event) {
                            return _vm.changeTab(2)
                          },
                        },
                      },
                      [
                        _c(
                          "v-flex",
                          [
                            _vm._v(" Failed Tests by Severity "),
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-unfold-more-horizontal"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "transition",
                          [
                            _c(
                              "keep-alive",
                              [
                                _vm.tab == 0 && _vm.ableTab
                                  ? _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "v-row",
                                          { attrs: { dense: "" } },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: {
                                                  color: "#303030",
                                                  "max-width": "100%",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-slide-group",
                                                  {
                                                    attrs: {
                                                      "show-arrows": true,
                                                      elevation: 0,
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.files,
                                                    function (file, i) {
                                                      return _c(
                                                        "v-slide-item",
                                                        {
                                                          key: i,
                                                          staticClass:
                                                            "mx-2 my-2",
                                                        },
                                                        [
                                                          _c(
                                                            "v-card",
                                                            {
                                                              staticClass:
                                                                "fill-height",
                                                            },
                                                            [
                                                              _c(
                                                                "v-card-title",
                                                                {
                                                                  staticClass:
                                                                    "justify-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "center",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("em", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            i +
                                                                              1
                                                                          )
                                                                        ),
                                                                      ]),
                                                                      _c("br"),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            file.filename
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      _c("br"),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .fileTimes[
                                                                                i
                                                                              ]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      file.database_id
                                                                        ? _c(
                                                                            "TagRow",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  "max-width":
                                                                                    "400px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  evaluation:
                                                                                    _vm.toIEvaluation(
                                                                                      file
                                                                                    ),
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-card-actions",
                                                                {
                                                                  staticClass:
                                                                    "justify-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "StatusChart",
                                                                    {
                                                                      attrs: {
                                                                        filter:
                                                                          {
                                                                            fromFile:
                                                                              [
                                                                                file.uniqueId,
                                                                              ],
                                                                            omit_overlayed_controls: true,
                                                                          },
                                                                        "show-compliance": true,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.tab == 1 && _vm.ableTab
                                  ? _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("ApexLineChart", {
                                          attrs: {
                                            series: _vm.compliance_series,
                                            categories: _vm.fileTimes,
                                            "upper-range": 100,
                                            title: "Total Compliance",
                                            "y-title": "% Compliance",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.tab == 2 && _vm.ableTab
                                  ? _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("ApexLineChart", {
                                          attrs: {
                                            series: _vm.line_sev_series,
                                            categories: _vm.fileTimes,
                                            "upper-range": _vm.total_failed + 1,
                                            "sev-chart": true,
                                            title: "Failed Tests by Severity",
                                            "y-title": "Tests Failed",
                                            "tooltip-max-display-precision": 0,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("v-col", { attrs: { cols: "12" } }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-card",
                  [
                    _c(
                      "v-row",
                      { attrs: { "no-gutters": "", dense: "" } },
                      [
                        _c("v-card-title", { staticClass: "mr-auto" }, [
                          _vm._v("Test Results"),
                        ]),
                        _c("v-checkbox", {
                          staticClass: "mr-3",
                          attrs: {
                            dense: "",
                            color: "blue",
                            label: "Display Only Changed Results",
                          },
                          model: {
                            value: _vm.changedOnly,
                            callback: function ($$v) {
                              _vm.changedOnly = $$v
                            },
                            expression: "changedOnly",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("hr"),
                    _c(
                      "v-row",
                      { attrs: { dense: "" } },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "3", sm: "2", md: "1" } },
                          [
                            _c("br"),
                            _c(
                              "v-row",
                              [
                                _c("v-col", { attrs: { cols: "8" } }, [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            float: "left",
                                            "padding-bottom": "8px",
                                            "padding-left": "7px",
                                          },
                                          attrs: { icon: "", small: "" },
                                          on: { click: _vm.changeSort },
                                        },
                                        [
                                          _vm.ascending
                                            ? _c("v-icon", [
                                                _vm._v("mdi-sort-descending"),
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-sort-ascending"),
                                              ]),
                                        ],
                                        1
                                      ),
                                      _c("strong", [_vm._v("Test ID")]),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticStyle: { float: "right" },
                                        attrs: { icon: "", small: "" },
                                      },
                                      [
                                        _vm.files.length > _vm.num_shown_files
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  disabled: _vm.startIndex == 0,
                                                },
                                                on: { click: _vm.scroll_left },
                                              },
                                              [_vm._v("mdi-arrow-left")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._l(_vm.num_shown_files, function (i) {
                          return _c("ProfileRow", {
                            key: i - 1 + _vm.startIndex,
                            attrs: {
                              name: _vm.files[i - 1 + _vm.startIndex].filename,
                              "start-time": _vm.fileTimes[i - 1],
                              index: i + _vm.startIndex,
                              "show-index":
                                _vm.files.length > _vm.num_shown_files,
                            },
                          })
                        }),
                        _c(
                          "v-col",
                          { attrs: { cols: "1" } },
                          [
                            _c("br"),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "v-btn",
                                      { attrs: { icon: "", small: "" } },
                                      [
                                        _vm.files.length > _vm.num_shown_files
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.startIndex >=
                                                    _vm.files.length -
                                                      _vm.num_shown_files,
                                                },
                                                on: { click: _vm.scroll_right },
                                              },
                                              [_vm._v("mdi-arrow-right")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _c("v-divider", { attrs: { dark: "" } }),
                    _vm._l(_vm.show_sets, function ([control_id, control_set]) {
                      return _c("CompareRow", {
                        key: control_id,
                        staticClass: "my-4",
                        attrs: {
                          "file-ids": _vm.visible_row_ids,
                          "control-id": control_id,
                          controls: control_set,
                          shift: _vm.startIndex,
                          expanded: _vm.expandedView,
                        },
                      })
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }